import { useRevalidator } from 'react-router';
import { courtApi } from '@repo/api-client';
import { useForm } from '@repo/ui/hooks/use-form';
import { Input } from '@repo/ui/components/form/input';
import { Select } from '@repo/ui/components/form/select';
import { Button } from '@repo/ui/components/button';

interface CreateCourtFormProps {
  clubId: string;
  onClose: () => void;
}

export const CreateCourtForm = ({ clubId, onClose }: CreateCourtFormProps) => {
  const revalidator = useRevalidator();

  const onSubmit = async () => {
    await courtApi.create(clubId, values);
    revalidator.revalidate();
    onClose();
  };

  const { ref, values, errors } = useForm<CreateCourt>({
    initialValues: {
      name: '',
      type: 'INDOOR',
      mode: 'DOUBLE',
    },
    onSubmit,
  });

  return (
    <form ref={ref} className="grid gap-4">
      <Input label="Nombre" type="text" name="name" required errors={errors} />
      <Select
        label="Tipo"
        options={[
          { value: 'INDOOR', label: 'Indoor' },
          { value: 'OUTDOOR', label: 'Outdoor' },
        ]}
        name="type"
        required
        errors={errors}
      />
      <Select
        label="Modo"
        options={[
          { value: 'SINGLE', label: 'Single' },
          { value: 'DOUBLE', label: 'Double' },
        ]}
        name="mode"
        required
        errors={errors}
      />
      <Button type="submit">Crear</Button>
    </form>
  );
};
